var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.25 2a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V3.81l-8.72 8.72a.75.75 0 1 1-1.06-1.06l8.72-8.72H17a.75.75 0 0 1-.75-.75ZM9.966 3.25H13a.75.75 0 0 1 0 1.5h-3c-1.413 0-2.427 0-3.223.066-.787.064-1.295.188-1.706.397a4.25 4.25 0 0 0-1.858 1.858c-.21.411-.333.919-.397 1.706-.065.796-.066 1.81-.066 3.223v2c0 1.412 0 2.427.066 3.223.064.787.188 1.295.397 1.707a4.25 4.25 0 0 0 1.858 1.857c.411.21.919.333 1.706.397.796.065 1.81.066 3.223.066h2c1.412 0 2.427 0 3.223-.066.787-.064 1.295-.188 1.707-.397a4.251 4.251 0 0 0 1.857-1.857c.21-.412.333-.92.397-1.707.065-.796.066-1.81.066-3.223v-3a.75.75 0 0 1 1.5 0v3.034c0 1.371 0 2.447-.07 3.311-.072.88-.221 1.607-.557 2.265a5.75 5.75 0 0 1-2.513 2.513c-.658.336-1.385.485-2.265.556-.864.071-1.94.071-3.311.071H9.966c-1.371 0-2.447 0-3.311-.07-.88-.072-1.607-.221-2.265-.557a5.75 5.75 0 0 1-2.513-2.513c-.336-.658-.484-1.385-.556-2.265-.071-.864-.071-1.94-.071-3.311v-2.068c0-1.371 0-2.447.07-3.311.073-.88.221-1.607.557-2.265A5.75 5.75 0 0 1 4.39 3.877c.658-.336 1.385-.484 2.265-.556.864-.071 1.94-.071 3.311-.071Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink2);
export default __webpack_public_path__ + "static/media/external_link_2.73ac903043fd1f781609148934b36c72.svg";
export { ForwardRef as ReactComponent };